import { components, ClearIndicatorProps, GroupBase } from "react-select";

import { ReactComponent as XCircleGrey } from "assets/images/iconsV2/x-circle-grey.svg";

import type { SelectOption } from "../types";

export default function SelectClearIndicator(
  props: ClearIndicatorProps<SelectOption, false, GroupBase<SelectOption>>,
) {
  return (
    <components.ClearIndicator {...props}>
      <XCircleGrey />
    </components.ClearIndicator>
  );
}
